import React, { useState } from "react";
import * as API from "lib/apis";
import { useLocalStorage } from "lib/useLocalStorage";
import { STORAGE_KEY, SERVICE_CODE } from "../constants";

const HOME_PATH = {
  [SERVICE_CODE.HANA]: "/hana-main",
};

const AuthTest = ({ history }) => {
  const [, setStoredServiceCode] = useLocalStorage(STORAGE_KEY.SERVICE_CODE);
  const [, setStoredAccessToken] = useLocalStorage(STORAGE_KEY.ACCESS_TOKEN);
  const [ci, setCi] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  if (process.env.REACT_APP_ENVIRONMENT === "prod") {
    return null;
  }

  const handleLogin = () => {
    if (!ci.trim()) {
      setError("ci 값을 입력해주세요.");
      return;
    }
    setError("");
    setIsLoading(true);

    API.signInWithCi(ci.trim(), SERVICE_CODE.HANA, (res) => {
      setIsLoading(false);
      if (!res || !res.success) {
        setError(res && res.message ? res.message : "로그인에 실패했습니다.");
        return;
      }
      setStoredAccessToken(res.data.token);
      setStoredServiceCode(SERVICE_CODE.HANA);

      history.push(`${HOME_PATH[SERVICE_CODE.HANA]}?serviceCode=${SERVICE_CODE.HANA}`);
    });
  };

  return (
    <div style={{ padding: 20 }}>
      <h3>임시 로그인 (개발용, 하나머니)</h3>
      <p style={{ color: "#888" }}>prod가 아닌 환경에서만 동작합니다.</p>

      <p>
        <label>
          ci&nbsp;
          <input
            type="text"
            value={ci}
            onChange={(e) => setCi(e.target.value)}
            placeholder="테스트할 사용자의 ci 값을 붙여넣으세요"
            style={{ width: 400 }}
          />
        </label>
      </p>

      {error && <p style={{ color: "red" }}>{error}</p>}

      <button onClick={handleLogin} disabled={isLoading}>
        {isLoading ? "로그인 중..." : "로그인"}
      </button>
    </div>
  );
};

export default AuthTest;
